import React, { useCallback, useState } from "react";
import { Input, Label } from "reactstrap";
import cx from "classnames";
import { TranslateWrapper } from "components/TranslateWrapper";
import type { InputType } from "reactstrap/types/lib/Input";
import type { TranslateWrapperProps } from "interfaces/shared.types";
import styles from "./Inputs.module.scss";

type UserNameInputProps = {
  type: InputType;
  value: string;
  label: string | { props: TranslateWrapperProps };
  error?: Error | null;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
  id: string;
  testId: string;
  classNames?: string;
};

export const UserNameInput = ({
  type,
  value,
  label,
  error,
  onChange,
  name,
  id,
  testId,
  classNames = "mb-3",
}: UserNameInputProps) => {
  const [isFocused, setIsFocused] = useState(false);

  const placeholderText = typeof label === "string" ? label : label.props.text;

  const toggleIsFocused = useCallback(() => {
    setIsFocused((val) => !val);
  }, []);

  return (
    <div className={cx(styles.wrapper, classNames)}>
      {(value || isFocused) && (
        <Label for={name} className={styles.label}>
          {typeof label === "string" ? (
            label
          ) : (
            <TranslateWrapper {...label.props} />
          )}
        </Label>
      )}
      <Input
        type={type}
        required
        placeholder={!isFocused ? placeholderText : ""}
        className={cx(styles.textInput, { "border-danger": error })}
        name={name}
        id={id}
        data-testid={testId}
        onChange={onChange}
        value={value}
        onFocus={toggleIsFocused}
        onBlur={toggleIsFocused}
      />
      {typeof label === "object" && (
        <TranslateWrapper
          tooltipText={label.props.tooltipText}
          tooltipId={id}
        />
      )}
    </div>
  );
};
